import { render, staticRenderFns } from "./ListPageMobile.vue?vue&type=template&id=048fe0c6"
import script from "./ListPageMobile.vue?vue&type=script&lang=js"
export * from "./ListPageMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports